import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import Divider from "@material-ui/core/Divider";
import Box from "@material-ui/core/Box";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import { makeStyles } from "@material-ui/core/styles";
import { encode } from "./Form/genericAdForm";
import CircularProgress from "@material-ui/core/CircularProgress";

const useStyles = makeStyles((theme) => ({
	DialogPaper: {
		minWidth: 480,
		maxWidth: "100%",
	},
	closeButton: {
		position: "absolute",
		right: theme.spacing(1),
		top: theme.spacing(1),
		color: theme.palette.grey[500],
	},
	button: {
		backgroundColor: "#08A742",
		fontSize: 16,
		fontWeight: 600,
		"&:hover": {
			background: "#08A742",
		},
	},
	submitButton: {
		minWidth: 214,
	},
	requestCallBackBtn: {
		background: "linear-gradient(90deg, rgba(8,167,66,1) 0%, rgba(97,199,134,1) 100%)",
		borderRadius: "9px",
		fontSize: "20px",
		fontWeight: "600",
		padding: ".5rem 2rem",
		width: "280px",
		height: "56px",
		fontFamily: "'Poppins', sans-serif",
	},
}));

export default function RequestCallBackModal() {
	const classes = useStyles();
	const [open, setOpen] = useState(false);
	const [name, setName] = useState("");
	const [phone, setPhone] = useState("");
	const [isSubmitted, setIsSubmitted] = useState(false);
	const [error, setError] = useState({});
	const [loading, setLoading] = useState(false);

	const handleClickOpen = () => {
		setOpen(true);
		setIsSubmitted(false);
	};

	const handleClose = () => {
		setOpen(false);
	};

	const handleSubmit = () => {
		if (!name.trim().length) {
			return setError({ name: "Please enter your Name" });
		} else setError({});
		if (!phone.trim().length) {
			return setError({ phone: "Please enter your Phone" });
		} else setError({});
		try {
			setLoading(true);
			// eslint-disable-next-line no-unused-vars
			fetch("/.netlify/functions/contact-us", {
				method: "POST",
				headers: { "Content-Type": "application/x-www-form-urlencoded" },
				body: encode({
					type: "GOOGLE ADS REQUEST CALL",
					name,
					phone,
				}),
			}).then(() => {
				if (typeof window.gtag === "function")
					window.gtag("event", "conversion", { send_to: "AW-615460128/F9KUCL_Oxb0CEKDavKUC" });
				// eslint-disable-next-line react/prop-types
				setIsSubmitted(true);
				setLoading(false);
			});
		} catch (e) {
			// eslint-disable-next-line no-console
			console.log(e);
			setLoading(false);
		}
	};

	return (
		<div>
			<Button className={classes.requestCallBackBtn} color="primary" onClick={handleClickOpen} variant="contained">
				Request a Call Back
			</Button>
			<Dialog aria-labelledby="form-dialog-title" fullWidth maxWidth={"xs"} onClose={handleClose} open={open}>
				<DialogContent>
					<IconButton aria-label="close" className={classes.closeButton} onClick={handleClose}>
						<CloseIcon />
					</IconButton>
					{!isSubmitted ? (
						<div>
							<Box fontSize="22px" fontWeight="700" mb={2} textAlign="center">
								Request a call back
							</Box>
							<TextField
								autoFocus
								error={error && error.name}
								fullWidth
								helperText={error && error.name}
								id="name"
								label="Name"
								margin="dense"
								onChange={(e) => setName(e.target.value)}
								required
								type="text"
								variant="outlined"
							/>
							<br />
							<br />
							<TextField
								error={error && error.phone}
								fullWidth
								helperText={error && error.phone}
								id="number"
								label="Phone"
								margin="dense"
								name="phone"
								onChange={(e) => setPhone(e.target.value)}
								// pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}"
								required
								type="number"
								variant="outlined"
							/>
							<Box p={4.5} textAlign="center">
								<Button
									className={classes.submitButton}
									color="secondary"
									disabled={loading}
									onClick={handleSubmit}
									size="medium"
									variant="contained"
								>
									Submit {loading && <CircularProgress className={classes.buttonProgress} size={24} />}
								</Button>
							</Box>
						</div>
					) : (
							<Box mb={6} mt={6} p={1.5} textAlign="center">
								<Box fontSize="18px" mt={1}>
									Submitted Successfully!
							</Box>
								<Divider />
								<Box mt={1}>
									One of our friendly staff will contact you at the earliest <br />
									and schedule demo for you.
							</Box>
							</Box>
						)}
				</DialogContent>
			</Dialog>
		</div>
	);
}
